/**
 * Resolve an asset's single operational identifier.
 * Prefers the computed `display_identifier` from the API (unit_name → fleet_number),
 * with defensive fallbacks for older API responses or partial payloads.
 */
export const assetDisplay = (a) =>
  (a && (a.display_identifier || a.unit_name || a.fleet_number)) || "";

/** Optional secondary tag (legacy fleet_number) shown after the primary label. */
export const assetLegacyTag = (a) => {
  if (!a) return "";
  const display = assetDisplay(a);
  const legacy = a.fleet_number;
  // Only show legacy when it differs from the display value (i.e. legacy record).
  return legacy && legacy !== display ? legacy : "";
};

/**
 * Finalization Phase F1 (Owner Rules J + 5): Coach-Name-first option
 * label for selector `<option>` elements. Fleet number is appended as
 * a small disambiguator ONLY when another asset in the same visible
 * list shares the exact Coach Name (per Owner Rule 5 — minimal
 * disambiguation, no broad subsystem). Never exposes raw UUIDs.
 */
export const coachOptionLabel = (asset, siblingsInList) => {
  if (!asset) return "";
  const name = (asset.unit_name || "").trim();
  const fleet = (asset.fleet_number || "").trim();
  if (name) {
    const collision = (siblingsInList || []).some(
      (other) => other && other.id !== asset.id && (other.unit_name || "").trim() === name,
    );
    return collision && fleet ? `${name} (#${fleet})` : name;
  }
  return fleet ? `#${fleet}` : "Unassigned Entertainer Coach";
};
